import './App.scss'
import AppRoutes from './Routes'

const App = () => {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  )
}

export default App
